import serviceTypeCodes from './serviceTypeCodes';

/** Legacy ES classes */
export const STD = 'STD';
export const SP = 'SP';
export const BP = 'BP';

/** Legacy ER classes */
export const ER_STANDARD = 'ER_STANDARD';
export const COMFORT = 'COMFORT';
export const PREMIUM = 'PREMIUM';

/** New ES classes */
export const NCO_DATE = '2024-11-04';
export const STANDARD = 'STANDARD';
export const PLUS = 'PLUS';
export const PREMIER = 'PREMIER';

/** Lyria classes */
export const LYRIA2 = 'LYRIA2';
export const LYRIA1 = 'LYRIA1';
export const LYRIABP = 'LYRIABP';

/** SNCF classes (National French Railway) */
export const SNCF2 = 'SNCF2';
export const SNCF1SP = 'SNCF1SP';
export const SNCF1BP = 'SNCF1BP';

/** SNCB classes (National Belgium Railway) */
export const SNCB2 = 'SNCB2';
export const SNCB1 = 'SNCB1';

/** DB classes */
export const DB1 = 'DB1';
export const DB2 = 'DB2';

/** NS classes */
export const NS1 = 'NS1';
export const NS2 = 'NS2';

/** ES classes names */
export const STANDARD_NAME = 'Standard';
export const EUROSTAR_PLUS_NAME = 'Eurostar Plus';
export const EUROSTAR_PLUS_NAME_FOR_SF = 'Plus';

export const SNCF_OPTIMUMPLUS = 'SNCFOPTIMUMPLUS';
export const SNCF_OPTIMUM = 'SNCFOPTIMUM';

/** Wheelchair */
export const WC_COMP = 'WC_COMP';
export const LYRIAWC = 'LYRIAWC';
export const SNCFWC = 'SNCFWC';
export const COMPANION = 'companion';
export const EVAC = 'EVAC';
export const UNASSIGNED = 'UNASSIGNED';

export const CLASSES_OF_SERVICE_BY_TYPE = {
  [STANDARD]: [STANDARD, ER_STANDARD, STD, LYRIA2, SNCF2, SNCB2, DB2, NS2],
  [PLUS]: [PLUS, COMFORT, SP, LYRIA1, SNCF1SP],
  [PREMIER]: [PREMIER, PREMIUM, BP, LYRIABP, SNCF1BP, SNCB1, DB1, NS1, SNCF_OPTIMUM, SNCF_OPTIMUMPLUS],
  [WC_COMP]: [WC_COMP, LYRIAWC, SNCFWC],
  [EVAC]: [EVAC],
  [UNASSIGNED]: [UNASSIGNED]
};

// Only 2 classes (SNCB1 and SNCB2)
export const CLASSES_OF_SERVICE_BY_TYPE_SNCB = {
  [STANDARD]: [SNCB2],
  [PREMIER]: [SNCB1]
};

export const CLASSES_OF_SERVICE_ORDER = {
  [PREMIER]: 1,
  [PLUS]: 2,
  [STANDARD]: 3,
  [LYRIABP]: 1,
  [LYRIA2]: 2,
  [LYRIA1]: 3
};

export const OLD_CLASSES_OF_SERVICE_BY_TYPE = {
  [STD]: [STANDARD, ER_STANDARD, STD],
  [SP]: [PLUS, COMFORT, SP],
  [BP]: [PREMIER, PREMIUM, BP],
  [WC_COMP]: [WC_COMP]
};

export const SEVEN_DAY_EXCHANGE_RULE_CLASSES_OF_SERVICE = [STD, ER_STANDARD, STANDARD, SP, COMFORT, PLUS];

export const LYRIA_SUMMATED_FARES_COS_PRIORITY_LIST = [LYRIA2, LYRIA1, LYRIABP, LYRIAWC];

export const SNCF_SUMMATED_FARES_COS_PRIORITY_LIST = [SNCF2, SNCF1SP, SNCF1BP, SNCF_OPTIMUM, SNCF_OPTIMUMPLUS, SNCFWC];
export const PLUS_SNCF_SUMMATED_FARES_COS_PRIORITY_LIST = [SNCF1SP, SNCF1BP, SNCF_OPTIMUM, SNCF_OPTIMUMPLUS, SNCF2, SNCFWC];
export const CARRIERS_WITH_TWO_CLASSES_OF_SERVICES = [serviceTypeCodes.SNCB, serviceTypeCodes.NS];
